import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.OrderService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class OrderService extends RpcClass{

    /**
     *  @class OrderService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/OrderService.OrderService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param order {module:src/server/com/silkplm/model/plm/Order.Order} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfAnyOrderDetailsExists(order) {
            return RpcClass.rpcCall('/rpc/plm/services/order-service/check-if-any-order-details-exists', [order]);
    }
    /** 
     * @async
     * @param printoutClass {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     checkIfHorizontalTemplateForPrintout(printoutClass) {
            return RpcClass.rpcCall('/rpc/plm/services/order-service/check-if-horizontal-template-for-printout', [printoutClass]);
    }
    /** 
     * @async
     * @param orderStatusId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfOrderStatusIsConfirmed(orderStatusId) {
            return RpcClass.rpcCall('/rpc/plm/services/order-service/check-if-order-status-is-confirmed', [orderStatusId]);
    }
    /** 
     * @async
     * @param termsOfPayment {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     getAdvanceOfTermsOfPayment(termsOfPayment) {
            return RpcClass.rpcCall('/rpc/plm/services/order-service/get-advance-of-terms-of-payment', [termsOfPayment]);
    }
    /** 
     * @async
     * @param orderId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     listOrderDetailsForOrder(orderId) {
            return RpcClass.rpcCall('/rpc/plm/services/order-service/list-order-details-for-order', [orderId]);
    }
    /** 
     * @async
     * @param orderId {string} 
     * @param language {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     orderDetailsPrintoutRawMaterialsPath(orderId, language) {
            return RpcClass.rpcCall('/rpc/plm/services/order-service/order-details-printout-raw-materials-path', [orderId, language]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.OrderService';
metadata.__type_short__ = 'OrderService';
OrderService.prototype.__metadata__ = metadata;

OrderService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/OrderService */
export default OrderService

export { OrderService }
